export const useStyles = () => ({
  tagInput: {
    width: 125,
    height: 36,
  },
});
